var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "verificationCodeInput"
  }, _vm._l(_vm.valueArray, function (value, i) {
    return _c('InputFrame', _vm._b({
      key: i
    }, 'InputFrame', {
      disabled: _vm.disabled,
      error: _vm.error,
      useGenericBackdropGradient: _vm.useGenericBackdropGradient
    }, false), [_c('input', {
      ref: "inputs",
      refInFor: true,
      attrs: {
        "pattern": "\\d*",
        "type": _vm.obscureValues ? 'password' : undefined,
        "autocomplete": "one-time-code"
      },
      domProps: {
        "value": value
      },
      on: {
        "input": function input(event) {
          return _vm.newInput(i, event.target);
        },
        "keydown": [function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
          return _vm.deletePressed(i, value);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) { return null; }
          if ('button' in $event && $event.button !== 0) { return null; }
          return function (event) {
            return _vm.leftPressed(i, event.target);
          }($event);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "right", 39, $event.key, ["Right", "ArrowRight"])) { return null; }
          if ('button' in $event && $event.button !== 2) { return null; }
          return function (event) {
            return _vm.rightPressed(i, event.target);
          }($event);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.$emit('returnKey');
        }]
      }
    })]);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }